import React from 'react';

interface FeatureCard {
  title: string;
  description: string;
  icon?: string;
}

const LearnFromRob: React.FC = () => {
  const features: FeatureCard[] = [
    {
      title: "1,800% Return on AbraSilver",
      description: "Rob led AbraSilver from a $5M to $600M market cap, delivering a massive 1,800% return to early investors."
    },
    {
      title: "400% Return on West Vault Mining",
      description: "He bought West Vault Mining at $0.30 and sold at $1.50 one year later - a 400% gain, perfectly timing the bottom."
    },
    {
      title: "3,700% Gain on Catamaran",
      description: "Rob initiated coverage on Catamaran below $2 per share - it later climbed to $76, resulting in a 3,700% return."
    }
  ];

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#fff] pt-20 pb-20">
      <div className="">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-[30px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7">
          Rob Bruggeman: A Master of Junior Mining Investing
          </h2>
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0 lg:text-justify text-center">
          Rob Bruggeman's expertise in junior mining investment is unmatched, forged over
          <strong> 25 years of navigating volatile markets. </strong> 
          As a professional research analyst and trader, Rob delivered
          <strong> exceptional results </strong>    
          including 40% annual returns (2005–2010) while managing an internal hedge fund for a major Canadian bank during the 2008 crisis. His bold market calls—such as shorting the TSX in mid-2008 and perfectly timing gold's bottom in 2016—demonstrate his strategic acumen. Rob's hands-on leadership in exploration companies, including transforming a struggling junior into a $600M leader, showcases his ability to spot high-potential junior mining stocks. Some of his key achivments:          </p>
        </div>

        {/* Features Grid - All Screen Sizes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-[#F6F6F6] rounded-[10px] p-6 sm:p-8 flex flex-col justify-start items-center text-center"
            >
              <div className="mb-3 flex flex-col items-center">
              
                <h3 className="text-[24px] leading-[32px] font-[700] text-[#000] text-center">
                  {feature.title}
                </h3>
              </div>
              <p className="text-[20px] leading-[32px] text-[#000] text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16 text-[16px] lg:text-[24px] md:text-[18px]">
          <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-[#0B6054] text-white px-10 py-3.5 rounded-[10px] font-semibold hover:bg-[#1A2A44] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#1A2A44] focus:ring-opacity-50 text-center">
            LEARN FROM ROB NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default LearnFromRob;
